<template>
  <div>
    <v-dialog v-model="dialog" max-width="500px" persistent>
      <v-card>
        <v-card-title>Confirm</v-card-title>
        <v-card-text>
          Are you sure you want to delete this chat?<br />
          SAVE will temporarily remove the chat from the list. <br />
          DELETE will permanently delete all the messages and remove the chat
          from the list.
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn text color="error" @click="dialog = false"> Cancel </v-btn>
          <v-btn text color="green" @click="save()"> Save </v-btn>
          <v-btn text color="error" @click="remove()">Delete</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import firebase from "firebase";
import { chat_list, functions, technicians } from "../../assets/js/firebase";
export default {
  data() {
    return {
      dialog: false,
      id: null,
      index: -1,
      type: "customer"
    };
  },
  methods: {
    init(id, index, type) {
      this.type = type;
      this.id = id;
      this.index = index;
      this.dialog = true;
    },
    async save() {
      const vm = this;
      try {
        vm.$loader.show();
        if (vm.type == "customer") {
          await chat_list.doc(vm.id).update({
            updated_at: firebase.firestore.FieldValue.delete()
          });
          vm.$parent.list.splice(vm.index, 1);
        } else {
          await technicians.doc(vm.id).update({
            chat_at: firebase.firestore.FieldValue.delete()
          });
        }
        vm.$loader.hide();
        vm.dialog = false;
        vm.$parent.click(vm.$parent.list[0], false);
      } catch (error) {
        vm.$loader.hide();
        vm.$alert.show(error.message);
      }
    },
    async remove() {
      const vm = this;
      try {
        vm.$loader.show();
        let { data } = await functions.httpsCallable("removeChat")({
          chat: vm.id
        });
        if (!data.status) {
          vm.$loader.hide();
          vm.$alert.show(data.message);
          return;
        }
        if (vm.type == "customer") {
          await chat_list.doc(vm.id).update({
            updated_at: firebase.firestore.FieldValue.delete()
          });
          vm.$parent.list.splice(vm.index, 1);
        } else {
          await technicians.doc(vm.id).update({
            chat_at: firebase.firestore.FieldValue.delete()
          });
        }
        vm.$loader.hide();
        vm.dialog = false;
        vm.$parent.click(vm.$parent.list[0], false);
      } catch (error) {
        vm.$loader.hide();
        vm.$alert.show(error.message);
      }
    }
  }
};
</script>

<style></style>
